import fComponents from "../../web-sh/src/components/forms";

import CreditCardForm from "./CreditCardForm";
import ImportForm from "./ImportForm";
import PrivateEmails from "./PrivateEmails";

fComponents.ImportForm = ImportForm;

const formsComponents = {
  ...fComponents,
  CreditCardForm,
  PrivateEmails
};

export default formsComponents;